import './NotificationSkeletonWave.css';

const NotificationSkeletonWave = ({ key,notificationsType }) => {
  const shouldShowRightAvatar = notificationsType !== "social" && notificationsType !== "clinical-session";
  return (
    <div key={key} className="notification-wave-container">
      <div className="notification-wave-header">
        <span className="notification-wave-bullet skeleton-wave"></span>
        <span className="notification-wave-date skeleton-wave"></span>
      </div>
      <div className="notification-wave-content">
        <div className="notification-wave-avatar skeleton-wave"></div>
        <div className="notification-wave-text">
          <div className="notification-wave-name skeleton-wave"></div>
          <div className="notification-wave-action skeleton-wave"></div>
        </div>
        {shouldShowRightAvatar && (
          <div className="notification-wave-avatar-right skeleton-wave"></div>
        )}
      </div>
    </div>
  );
};

export default NotificationSkeletonWave;
